import React, { useState } from 'react';
import s from './SalonFilterPage.module.scss'
import clsx from 'clsx'
import { ReactComponent as Plus } from 'images/new-icons/plus-with-backgorund.svg';
import { ReactComponent as Kre } from 'images/new-icons/kre.svg';
const options = ['Recommended', 'Top rated', 'New', 'Top', 'Popular', 'Next to me'];

const SelectableButtons: React.FC = () => {
    const [selected, setSelected] = useState<string[]>([]);

    const handleToggle = (option: string) => {
        if (selected.includes(option)) {
            setSelected(selected.filter((item) => item !== option));
        } else {
            setSelected([...selected, option]);
        }
    };

    return (
        <div className={s.selectable_buttons}>
            {options.map((option) => (
                <button
                    key={option}
                    className={clsx(s.selectable_buttons__button, selected.includes(option) ? s.selectable_buttons__button__selected : '')}
                    onClick={() => handleToggle(option)}
                >
                    {option} <span className={s.selectable_buttons__icon}>{selected.includes(option) ? <Kre /> : <Plus />}</span>
                </button>
            ))
            }
        </div >
    );
};

export default SelectableButtons;
